// tslint:disable:max-line-length

import React from 'react';

export const ActionSchedule = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2z M7,4v4.6 l0.6,0.3l2,1l0.9,0.4l0.9-1.8l-0.9-0.5L9,7.4V4H7z" />
    </svg>
  );
};
